var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageActivity = function SvgMypageActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M4.85 21.75h16.9V2.25H2.25v16.9a2.6 2.6 0 0 0 2.6 2.6m0-5.85V4.85h14.3V15.9H14.6a2.6 2.6 0 1 1-5.2 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    d: "M4.85 4.85V15.9H9.4a2.6 2.6 0 0 0 5.2 0h4.55V4.85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M6.8 8.1h10.4V6.8H6.8zm0 2.6h10.4V9.4H6.8zm5.2 2.6H6.8V12H12z",
    clipRule: "evenodd"
  })));
};
export default SvgMypageActivity;